import { createRouter, createWebHistory } from "vue-router";

import index from "@/views/Pc/index";

/**
 * 创建路由对象
 */
const routes_PC = [
  {
    path: "/",
    meta: {
      title: "Yuliverse",
    },
    component: index,
  },
  {
    path: "/PrivacyPolicy/ios", //隐私政策
    meta: {
      title: "Metaport Yuliverse Privacy Policy",
    },
    component: () => import("@/views/Pc/documents/PrivacyPolicy_ios.vue"),
  },
  {
    path: "/PrivacyPolicy/android", //隐私政策
    meta: {
      title: "Metaport Yuliverse Privacy Policy",
    },
    component: () => import("@/views/Pc/documents/PrivacyPolicy_android.vue"),
  },
  {
    path: "/Agreement/ios", //用户协议
    meta: {
      title: "End User License Agreement",
    },
    component: () => import("@/views/Pc/documents/Agreement_ios.vue"),
  },
  {
    path: "/Agreement/android", //用户协议
    meta: {
      title: "End User License Agreement",
    },
    component: () => import("@/views/Pc/documents/Agreement_android.vue"),
  },
  {
    path: "/MoonPoints",
    meta: {
      title: "Moon Points"
    },
    component: () => import("@/views/H5/MoonPoints")
  }
];

const routes = [...routes_PC];
//创建路由
const router = createRouter({
  history: createWebHistory(),
  routes, //定义的路由
});
// 路由拦截操作
router.beforeEach((to, from, next) => {
  // 拦截标题配置
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
